import * as React from "react";
import { FolderOpen, Mail, ShieldCheck } from "lucide-react";
import { cn } from "@/lib/utils";

interface CoreFeature {
  icon: React.ReactNode;
  title: string;
  description: string;
}

const CORE_FEATURES: CoreFeature[] = [
  {
    icon: <FolderOpen className="h-5 w-5" strokeWidth={1.8} />,
    title: "Dokumentenmanagement (DMS)",
    description:
      "Zentrales Ablagesystem für alle Belege, Verträge und Dokumente – mit Volltextsuche und Versionierung.",
  },
  {
    icon: <Mail className="h-5 w-5" strokeWidth={1.8} />,
    title: "E-Mail & Versandkanal",
    description:
      "Direkter E-Mail-Versand aus der Plattform heraus – für Rechnungen, Angebote und Benachrichtigungen.",
  },
  {
    icon: <ShieldCheck className="h-5 w-5" strokeWidth={1.8} />,
    title: "Benutzer & Berechtigungen",
    description:
      "Rollenbasierte Zugriffskontrolle für alle Nutzer – konfigurierbar pro Modul und Aktion.",
  },
];

interface CoreIncludedProps {
  className?: string;
  compact?: boolean;
}

export const CoreIncluded = React.forwardRef<HTMLDivElement, CoreIncludedProps>(
  ({ className, compact = false }, ref) => {
    return (
      <div ref={ref} className={cn("rounded-2xl border border-border bg-muted/40 p-6", className)}>
      {/* Header */}
      <div className="mb-5">
        <span className="inline-flex items-center rounded-full border border-success/30 bg-success/8 px-3 py-1 text-xs font-semibold text-success mb-2">
          Plattform inklusive
        </span>
        <h3 className="font-display font-bold text-lg text-foreground">
          In jedem Plan enthalten
        </h3>
        <p className="text-sm text-muted-foreground mt-1">
          Diese Kernfunktionen sind kein Modul – sie gehören zur Plattform.
        </p>
      </div>

      {/* Feature cards */}
      <div className={cn("grid gap-4", compact ? "grid-cols-1" : "grid-cols-1 sm:grid-cols-3")}>
        {CORE_FEATURES.map((feature) => (
          <div
            key={feature.title}
            className="flex flex-col gap-2 rounded-xl border border-border bg-card p-4 shadow-card"
          >
            <div className="inline-flex h-9 w-9 items-center justify-center rounded-lg bg-primary/10 text-primary">
              {feature.icon}
            </div>
            <p className="font-display font-semibold text-sm text-foreground leading-snug">
              {feature.title}
            </p>
            <p className="text-xs text-muted-foreground leading-relaxed">
              {feature.description}
            </p>
          </div>
        ))}
      </div>
    </div>
    );
  },
);
CoreIncluded.displayName = "CoreIncluded";
